export async function subscribeToUser(
  backendUrl: string,
  targetUserId: string,
) {
  const response = await fetch(`${backendUrl}/api/user-subscriptions`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      target_user_id: targetUserId,
    }),
  })

  return await response.json()
}
